import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import {
    NewsroomPressOneColumnTemplate,
    NewsroomPressTwoColumnsTemplate,
} from "./press-block.templates";

export default {
    title: "Website/Partial Templates/Newsroom Blocks/Press Block",
    render: NewsroomPressOneColumnTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

export const OneColumn = {};

export const TwoColumns = {
    render: NewsroomPressTwoColumnsTemplate.bind({}),
};
